<script>
import FullScreenAnimationHandler from "@/core/full-screen-animation-handler";

import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "EnterDilationModal",
  components: {
    ModalWrapperChoice
  },
  computed: {
    message() {
      return `Растяжение времени начнёт новую Вечность, и все степени множителей Измерений и
        степени множителей скорости тика будут уменьшены до ${formatPow(0.75, 2, 2)}. Если вы сможете начать Вечность
        внутри растяжения, ваши Тахион Частицы будут увеличены до значения, основанного на наибольшем количестве
        Антиматерии и на множителях Тахион Частиц, которые у вас есть.`;
    },
    entranceLabel() {
      return `Вы собираетесь начать Растяжение`;
    },
    EPSinceLabel() {
      if (player.dilation.lastEP.eq(-1)) {
        return "Это ваше первое Растяжение";
      }
      if (!isInCelestialReality() && Ra.unlocks.unlockDilationStartingTP.canBeApplied) {
        return `Вы уже обладаете наибольшим допустимым количеством Тахион Частиц, которого вы можете достигнуть,
          благодаря награде за ${formatInt(25)} Уровень Терезы.`;
      }
      return `Последний раз вы закончили Растяжение на ${format(player.dilation.lastEP, 2, 2)} Очках Вечности.`;
    }
  },
  methods: {
    handleYesClick() {
      if (player.dilation.active) return;
      if (player.options.animations.dilation && !FullScreenAnimationHandler.isDisplaying) {
        // Strike trigger happens within the delayed dilation callback in this function
        animateAndDilate();
      } else {
        startDilatedEternity();
        if (Pelle.isDoomed) PelleStrikes.dilation.trigger();
      }
    },
  },
};
</script>

<template>
  <ModalWrapperChoice
    option="dilation"
    @confirm="handleYesClick"
  >
    <template #header>
      {{ entranceLabel }}
    </template>
    <div class="c-modal-message__text">
      {{ EPSinceLabel }}
      <br>
      <br>
      {{ message }}
    </div>
    <template #confirm-text>
      Войти
    </template>
  </ModalWrapperChoice>
</template>
